import React from 'react';
import { useLanguage } from './LanguageContext';

/**
 * EN/TH switch. It renders in three places — the desktop sidebar footer, the
 * phone nav-drawer footer (both --brand-900) and the near-white MobileHeader
 * bar — so its colours cannot be inline: they live in `.lang-toggle` in
 * index.css, with a light variant under `.mobile-header .lang-toggle`. The
 * hardcoded #d1d5db this used to carry measured 1.47:1 on the header.
 */
const LanguageToggle = () => {
  const { currentLanguage, toggleLanguage } = useLanguage();

  return (
    <button type="button" className="lang-toggle" onClick={toggleLanguage}>
      <svg
        aria-hidden="true"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
      {currentLanguage === 'en' ? 'EN' : 'TH'}
    </button>
  );
};

export default LanguageToggle;
